export const spaceName = 'odSettingPrint';
export interface PrintSettings {
  printerData: any;
  pollingStatus: 'running' | 'stop';
  showDrawer: {
    show: boolean;
    type?: 'add' | 'edit';
    addType?: 'normalPrinter' | 'piPrinter';
  };
  editingPrinterInfo: any;
}

export default {
  showDrawer: {
    show: false,
  },
} as PrintSettings;

export const getPrintListColumns = (props: any) => {
  const {
    helper: { tx },
    actionButton,
    status,
  } = props;

  return [
    {
      title: tx('Global.service_name'),
      dataIndex: 'service',
      key: 'service',
      width: '150px',
      fixed: 'left',
    },
    {
      title: tx('Global.type'),
      dataIndex: 'type',
      key: 'type',
      width: '100px',
    },
    { ...status },
    {
      title: tx('Global.last_check'),
      dataIndex: 'lastCheck',
      key: 'lastCheck',
      width: '200px',
    },
    {
      title: tx('Global.mac'),
      dataIndex: 'mac',
      key: 'mac',
      width: '200px',
    },
    {
      title: tx('Global.ip_list'),
      dataIndex: 'iplist',
      key: 'ipList',
      width: '200px',
    },
    { ...actionButton },
  ];
};
